import React from 'react';
import { IconCircleColorCheck, IconFour, IconOne, IconRectangule, IconThree, IconTwo } from '../icons';
import Styles from './create-account-header-styles.scss';
import { TabName } from './create-account-header-types';
const CreateAccountHeader = ({ selectedTab = TabName.ACCOUNT_INFO, indexMax = 0, isAccountInfoCheck = false, isAddTeachersCheck = false, isAddStudentsCheck = false, isPaymentInfoCheck = false, isSmallOrFreePlan = false, isUpgradeFlow = false }) => {
    const SELECTED_COLOR = '#000000';
    const NOT_SELECTED_COLOR = '#999999';
    const getNumber = (tabName) => {
        if (isUpgradeFlow) {
            switch (tabName) {
                case TabName.ADD_TEACHERS:
                    return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                case TabName.ADD_STUDENTS:
                    return React.createElement(IconTwo, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                case TabName.PAYMENT_INFO:
                    return React.createElement(IconThree, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                default:
                    return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            }
        }
        if (isSmallOrFreePlan) {
            switch (tabName) {
                case TabName.ACCOUNT_INFO:
                    return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                case TabName.ADD_STUDENTS:
                    return React.createElement(IconTwo, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                case TabName.PAYMENT_INFO:
                    return React.createElement(IconThree, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
                default:
                    return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            }
        }
        switch (tabName) {
            case TabName.ACCOUNT_INFO:
                return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            case TabName.ADD_TEACHERS:
                return React.createElement(IconTwo, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            case TabName.ADD_STUDENTS:
                return React.createElement(IconThree, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            case TabName.PAYMENT_INFO:
                return React.createElement(IconFour, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
            default:
                return React.createElement(IconOne, { color: selectedTab === tabName ? SELECTED_COLOR : NOT_SELECTED_COLOR });
        }
    };
    return (React.createElement("div", { className: Styles.wrapper },
        React.createElement("div", { className: Styles.createYourAccountText }, isUpgradeFlow ? 'Upgrade Your Subscription' : 'Create Your Account'),
        React.createElement("div", { className: Styles.accountHeaderFullScreen },
            React.createElement("div", { className: Styles.navigationBar },
                !isUpgradeFlow && (React.createElement("div", { className: Styles.tab },
                    isAccountInfoCheck === true ? (React.createElement("div", { className: Styles.iconWrapper },
                        React.createElement(IconCircleColorCheck, null))) : (React.createElement("div", { className: Styles.iconWrapper }, getNumber(TabName.ACCOUNT_INFO))),
                    React.createElement("div", { className: selectedTab === TabName.ACCOUNT_INFO ? Styles.selectedText : Styles.notSelectedText }, "Account Info"))),
                (!isSmallOrFreePlan || isUpgradeFlow) && (React.createElement(React.Fragment, null,
                    !isUpgradeFlow && (React.createElement("div", { className: Styles.tab },
                        React.createElement(IconRectangule, null))),
                    React.createElement("div", { className: Styles.tab },
                        isAddTeachersCheck === true ? (React.createElement("div", { className: Styles.iconWrapper },
                            React.createElement(IconCircleColorCheck, null))) : (React.createElement("div", { className: Styles.iconWrapper }, getNumber(TabName.ADD_TEACHERS))),
                        React.createElement("div", { className: selectedTab === TabName.ADD_TEACHERS ? Styles.selectedText : Styles.notSelectedText }, "Add Teachers")))),
                React.createElement("div", { className: Styles.tab },
                    React.createElement(IconRectangule, null)),
                React.createElement("div", { className: Styles.tab },
                    isAddStudentsCheck === true ? (React.createElement("div", { className: Styles.iconWrapper },
                        React.createElement(IconCircleColorCheck, null))) : (React.createElement("div", { className: Styles.iconWrapper }, getNumber(TabName.ADD_STUDENTS))),
                    React.createElement("div", { className: selectedTab === TabName.ADD_STUDENTS ? Styles.selectedText : Styles.notSelectedText }, "Add Students")),
                React.createElement("div", { className: Styles.tab },
                    React.createElement(IconRectangule, null)),
                React.createElement("div", { className: Styles.tab },
                    isPaymentInfoCheck === true ? (React.createElement("div", { className: Styles.iconWrapper },
                        React.createElement(IconCircleColorCheck, null))) : (React.createElement("div", { className: Styles.iconWrapper }, getNumber(TabName.PAYMENT_INFO))),
                    React.createElement("div", { className: selectedTab === TabName.PAYMENT_INFO ? Styles.selectedText : Styles.notSelectedText }, "Payment Info")))),
        React.createElement("div", { className: Styles.accountHeaderMobileScreen },
            "Step",
            ' ',
            isSmallOrFreePlan
                ? selectedTab === TabName.ACCOUNT_INFO
                    ? 1
                    : selectedTab === TabName.ADD_STUDENTS
                        ? 2
                        : 3
                : selectedTab === TabName.ACCOUNT_INFO
                    ? 1
                    : selectedTab === TabName.ADD_TEACHERS
                        ? 2
                        : selectedTab === TabName.ADD_STUDENTS
                            ? 3
                            : 4,
            "/",
            indexMax)));
};
export default CreateAccountHeader;
